export enum ActiveTabs {
  Personal = 'Personal',
  Contact = 'Contact',
  Entrepreneur = 'Entrepreneur',
  Bank = 'Bank',
}
